export const transformProgressDetailsDto = details => {
  const {
    status,
    title,
    exact_date,
    date,
    note
  } = details;
  return {
    status,
    title,
    exactDate: exact_date,
    date,
    note
  };
};